import React from 'react';
import { StyleSheet, css } from 'aphrodite';

import { AppStyles, AppTheme } from '../../../styles/AppTheme';
import { BaseEntityPage } from '../../../common/components/BaseEntityPage';
import { Status } from '../../../components/Status';
import { venueMarkerData } from '../../../data/data';

export class DashboardPartner extends BaseEntityPage {
  constructor(props) {
    super(props);
    this.orgId = this.props.match.params.orgId
    this.pageTitle = 'Dashboard'
    this.toFetch = []
    this.noAdd = true
    this.state = {
      cards: [
        {
          title: 'Active Screens',
          value: 21
        },
        {
          title: 'Total Campaigns',
          value: 120
        },
        {
          title: 'Media Duration',
          value: '01:23:42'
        },
        {
          title: 'Total Media',
          value: 321
        }
      ],
      defaultLocation: {
        lat: 40.7127753,
        lng: -74.0059728,
        name: 'New York, NY, USA'
      }
    }
  }

  //map and places
  getMapContainer = () => {
    return (
      <div id={'map'} className={css(Styles.mapContainer)}></div>
    )
  }
  //loading the map with markers
  loadMap = (data) => {
    try {
      const locationItem = this.props.selectedLocation ? this.props.selectedLocation : this.state.defaultLocation
      const iconImg = require('../../../assets/images/map-marker.svg')
      const map = new window.google.maps.Map(document.getElementById('map'), {
        zoom: 10,
        center: locationItem,
      })
      data && data.items.forEach(function (item, i) {
        const marker = new window.google.maps.Marker({
          position: item.location,
          map,
          optimized: false,
          icon: iconImg
        });
      });
    } catch (err) {
      console.log('Google map load failed',err)
    }
  }
  onFetchSuccess() {
    this.loadMap(venueMarkerData)
  }
  renderAboveTable() {
    return (
      <div className={css(AppStyles.container, Styles.mainContainer)}>
        <div className={css(Styles.statusHolder)}>
          {this.state.cards && <Status items={this.state.cards} spacing={3} tileSize={3} valueStyle={Styles.valueStyle} ></Status>}
        </div>
        <div className={css(Styles.container)}>
          {this.getMapContainer()}
        </div>
      </div>
    );
  }
}

const Styles = StyleSheet.create({
  mainContainer: {
    backgroundColor: AppTheme.primaryBg,
    width: '100%',
    paddingLeft: 10,
    paddingRight: 10,
    paddingBottom: 10,
  },
  statusHolder: {
    display: 'flex',
    width: '100%'
  },
  container: {
    width: '100%'
  },
  mapContainer: {
    display: 'flex',
    flex: 1,
    width: '100%',
    height: 400,
    borderRadius: 40,
    backgroundColor: '#f5f5f5',
    '@media (max-width: 1024px)': {
      borderRadius: 20,
      minHeight: 600
    }
  },
  valueStyle: {
    color:AppTheme.buttonBg
  }
})


// WEBPACK FOOTER //
// ./src/screens/admin/partners/DashboardPartner.js